import { ILegacyFullStockObject } from '@classes/legacy-full-stock-object';
import {
  LegacyProductSkuModel,
  PartialLegacyProductSkuModel,
} from '@classes/legacy-product-sku-model';

import {
  assign,
  flow,
  forEach,
  isUndefined,
  map,
  merge,
  pick,
  sortBy,
  uniqBy,
} from 'lodash';

const SKU_LEVEL_PROPERTIES = [
  'barcode',
  'colorFamily',
  'maincolordescription',
  'qty',
  'size',
  'sizeindex',
  'subcolordescription',
  'variant',
];

const PRODUCT_LEVEL_PROPERTIES = [
  'brand',
  'code',
  'colorFamily',
  'description',
  'maincolor',
  'price',
  'shop',
  'subcolor',
  'suppliercolor',
  'warehouseid',
];

/**
 * Legacy product model, as used on softwear6#/article-info
 */
export class LegacyProductModel {
  brand: string;
  code: string;
  shop: string;
  description: string;
  warehouseid: string;
  // on product level, following wholesale/app/scripts/classes/product-object case
  price: number;

  // contrary to  wholesale/app/scripts/classes/product-object case,
  // where it was sku level
  maincolor: string;
  subcolor: string;
  suppliercolor: string;

  skus: LegacyProductSkuModel[];

  // TODO POS-1859 add unit test
  constructor(originalValue?: PartialLegacyProductModel) {
    merge(this, originalValue);
  }

  /**
   * @description
   * Returns an array of color objects based on the available colors in the product
   * ```
   * [ 's', 'm', 'l' ]
   * ```
   * @returns {strigt[]} array of sizes
   */
  // TODO POS-1859 add unit test
  // TODO CORE-1722 remove code duplication
  getSizes(): string[] {
    return flow([
      (x) => uniqBy(x, 'size'),
      (x) => sortBy(x, 'sizeindex'),
      (x) => map(x, (x) => x.size),
    ])(this.skus);
  }

  /**
   * @param {ILegacyFullStockObject[]} stock value to be used for setting object value
   * @description
   * Sets the object to the stock provided
   */
  // TODO POS-1859 add unit test
  setFromStock(stock: ILegacyFullStockObject[]) {
    const first = stock[0],
      skuIssues = [];

    assign(this, pick(first, PRODUCT_LEVEL_PROPERTIES));

    this.skus = <LegacyProductSkuModel[]>map(stock, (sku) => {
      return pick(sku, SKU_LEVEL_PROPERTIES);
    });

    forEach(this.skus, (sku) => {
      if (!isUndefined(sku.size)) {
        skuIssues.push(sku);
      }

      this[sku.size] = sku.qty;
    });

    if (skuIssues.length > 0) {
      // log those cases after we upgrade sentry on v6
    }
  }
}

export type PartialLegacyProductModel = Partial<
  Omit<LegacyProductSkuModel, 'skus'>
> & {
  skus?: PartialLegacyProductSkuModel[];
};
